import { createFileRoute } from "@tanstack/react-router";
import { useParams } from "@/lib/navigation";
import { CapitalCallsAdmin } from "@/components/CapitalCalls/Admin";

function RouteComponent() {
  const params = useParams();
  const id = params?.id as string;
  return <CapitalCallsAdmin id={id} />;
}

export const Route = createFileRoute("/_authenticated/capital-calls/$id/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
